import utils from 'utils'
class sharingGoodsCtrl {
    constructor($scope, logger, httpRequest, $uibModalInstance, modalParams) {
        $scope.isCar = modalParams.type ? true : false
        const words = modalParams.type ? '车辆' : '商品'
        $scope.title = `${words}共享`
        const listAPI = modalParams.type ? 'post_qryPublicVehicleGood' : 'post_qryPublicGoodsInfo'
        const shareAPI = modalParams.type ? 'post_syncVehicleGood' : 'post_syncGoodsInfo'
        const allAPI = modalParams.type ? 'post_syncAllVehicleGood' : 'post_syncAllGoodsInfo'
        $scope.param = {
            param: '',
            pageSize: 10,
            pageNum: 1
        }
        $scope.dictData = modalParams.dictData
        $scope.selectedArr = []
        $scope.queryList = function () {
            utils.loading('数据加载中')
            httpRequest[listAPI]($scope.param).then(res => {
                $scope.listData = res.data.value.list
                $scope.totalItems = res.data.value.total
            }).finally(() => {
                utils.loaded()
            })
        }
        $scope.queryList()
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss()
        }
        $scope.ok = function () {
            if (!$scope.selectedArr.length) return logger.logError(`未选择${words}信息！`)
            let ids = []
            for (const key in $scope.selectedArr) {
                if ($scope.selectedArr[key].sync == 1) {
                    return logger.logError(`存在已同步${words}信息！`)
                }
                $scope.isCar ? ids.push($scope.selectedArr[key].goodId) : ids.push($scope.selectedArr[key].goodsId)
            }
            httpRequest[shareAPI](ids).then((res) => {
                logger.logSuccess(`成功同步${res.data.value}条${words}信息`)
                $uibModalInstance.close()
            })
        }
        let flag = false
        $scope.okAll = function () {
            if (flag) return
            flag = true
            httpRequest[allAPI]($scope.param.param).then((res) => {
                logger.logSuccess(`成功同步${res.data.value}条${words}信息`)
                $uibModalInstance.close()
            })
        }
    }
}
sharingGoodsCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$uibModalInstance', 'modalParams']
export default sharingGoodsCtrl


// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/goodsInfo/sharingGoodsCtrl.js